import primaryButton from '../../../../primary-button';

const dark = (params) => primaryButton.brandedSolid.background.disabled.dark(params);

export default dark;
